import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosError} from 'axios';
import {message} from 'antd';

import {axiosRequest} from '../../helpers/request';
import {IBank, TBankState, IRequestError} from './banks-slice-types';

export const getBanks = createAsyncThunk<
    IBank[],
    number,
    {rejectValue: IRequestError}
>(
    "BANKS/LIST", async (localeId, thunkApi) => {
        try {
            const config = {headers: {"Content-Type": "application/json"}};
            const res = await axiosRequest.get(`/business-util/get-banks?localeId=${localeId}`, config);
            return res.data;
        } 
        catch (err:any) {
            let error: AxiosError<IRequestError> = err;
            if(!error.response){
                throw err;
            }
            return thunkApi.rejectWithValue(error.response.data)
        }
    }
);

const bankSlice = createSlice({
    name: 'banks',
    initialState: {
        bankStatus: 'idle',
        bankList: [],
    } as TBankState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getBanks.pending, (state, _) => {
            state.bankStatus = 'pending';
        })
        builder.addCase(getBanks.fulfilled, (state, {payload}) => {
            state.bankList = payload;
            state.bankStatus = 'succeeded';
        })
        builder.addCase(getBanks.rejected, (state, {payload, error}) => {
            state.bankList = [];
            state.bankStatus = 'failed';
            if(payload?.detail){
                message.error(payload.detail);
            }else{
                message.error(error.message)
            }
        })
    },
});

export default bankSlice.reducer;
